module.exports = __webpack_public_path__ + "01f43047/img/arrow-export-icon.a3345173.svg";